/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        class DetailLayoutDocumentRetrieval extends Navigation.DetailLayoutBaseClass {
            constructor(typeName, core, handler, custom, context, readyCallback = null, secondaryActivationCallback = null) {
                super(typeName, core, handler, custom, context, readyCallback, secondaryActivationCallback);
                this._autoListCollapse = "Hide";
                this.secondaryActivation = (context) => {
                    
                    // Local specialist processing
                    this._context = context;
                    let listWidgetSelector = '#topTablePlaceHolder .widget__collapse-target';
                    switch (context.ActivationType) {
                        case Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                            if ((this._autoListCollapse == "Hide") || ((this._autoListCollapse == "Responsive") && (this._core.Helper.isNarrowDevice()))) {
                                $(listWidgetSelector).collapse('hide');
                            }
                            break;
                        case Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                            $(listWidgetSelector).collapse('show');
                            break;
                    }
                    // Delegate the bulk fo the work to our owned widgets
                    super.secondaryActivation(context);
                };
                let appConfig = this._core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty("DetailViews")) {
                    let viewConfig = appConfig.DetailViews[this._name];
                    if (viewConfig != null) {
                        if (viewConfig.hasOwnProperty('CollapseListOnSelect'))
                            this._autoListCollapse = viewConfig.CollapseListOnSelect;
                    }
                }
            }
        }
        Navigation.DetailLayoutDocumentRetrieval = DetailLayoutDocumentRetrieval;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
